

const NoPermsisonRoute = () => {


    return (
        <h2>Please contact the admin to get the required permissions</h2>
    )

}


export default NoPermsisonRoute;